import React, { FunctionComponent, ReactNode } from 'react'

import styled from 'styled-components/native'

interface ResponsiveSvgContainerProps {
  shouldResize?: boolean
  children: ReactNode
}

const Container = styled.View<{ shouldResize?: boolean }>(({ shouldResize }) => ({
  ...(shouldResize && { width: '100%', height: '100%' }),
}))

/**
 * A container component for SVG illustrations that can either maintain their original dimensions
 * or resize to fill their parent container.
 *
 * @param shouldResize When true, the SVG will expand to fill its parent container
 * @param children The SVG content to be rendered inside the container
 */
export const ResponsiveSvgContainer: FunctionComponent<ResponsiveSvgContainerProps> = ({
  shouldResize = false,
  children,
}) => {
  return <Container shouldResize={shouldResize}>{children}</Container>
}

export default ResponsiveSvgContainer
